<template>
    <div class="servicePercentWrap" v-loading="isLoading">
       <div class="oneBtnBox">
            <el-button type="success" @click="refreshPage" size="mini">刷新页面</el-button>
        </div>
        <div class="panelBlock">
            <div class="panelTitle">
                接单支付金额比例：
            </div>
            <div class="panelContent">
                <div class="oneLine">
                    <input type="text" placeholder="请输入0-100的数字" v-model="inputFeeNum">%
                    <el-button type="primary" size="mini" @click="submitClick('produce_order_taking_fee')">确定</el-button>
                    <span class="importantDes">注意：谨慎，请勿随意修改！请同步修改底部接单时的比例支付</span>
                </div>
                <div class="oneLine">
                    当前付款比例: 
                    <span class="currentPercent">  
                        <b>{{infoObj.produce_order_taking_fee |times100 }}</b>
                        <b>%</b>
                    </span> 
                </div>
                
            </div>
        </div>
        <div class="panelBlock">
            <div class="panelTitle">
                订单详情页平台收费说明：
            </div>
            <div class="panelContent relativeBox">
                <div class="oneLine">
                    <span class="label">品牌商：</span>
                    <input type="text" class="editInput" v-model="infoObj.brand_order_detail_info">
                    <el-button type="primary" size="mini" @click="submitClick('brand_order_detail_info')">修改</el-button>
                </div>
                <div class="oneLine">
                    <span class="label">生产商：</span>
                    <textarea name="" id="" cols="50" rows="1" class="editInput" v-model="infoObj.produce_order_taking_detail_info"></textarea>

                    <el-button type="primary" size="mini" @click="submitClick('produce_order_taking_detail_info')">修改</el-button>
                </div>
                <div class="rightImgBox">
                    <viewer :images="photoArr1"> 
                        <img v-for="(src,index) in photoArr1"   :src="src" :key="index">
                    </viewer>
                </div>
                
            </div>
        </div>
        <div class="panelBlock">
            <div class="panelTitle">
                生产商接单页面文字说明：
            </div>
            <div class="panelContent relativeBox">
                <div class="oneLine">
                    <span class="label">说明概要：</span>
                    <textarea name="" id="" cols="50" rows="2" class="editInput" v-model="infoObj.produce_order_taking_notice_title"></textarea>
                    <el-button type="primary" size="mini" @click="submitClick('produce_order_taking_notice_title')">修改</el-button>
                </div>
                <div class="oneLine">
                    <span class="label">说明详情：</span>
                    <textarea name="" id="" cols="50" rows="4" class="editInput" v-model="infoObj.produce_order_taking_notice_content"></textarea>
                    <el-button type="primary" size="mini" @click="submitClick('produce_order_taking_notice_content')">修改</el-button>
                </div>
                <div class="rightImgBox">
                    <viewer :images="photoArr2"> 
                        <img v-for="(src,index) in photoArr2"   :src="src" :key="index">
                    </viewer>
                </div>
            </div>
            
        </div>
        
    </div>
</template>

<script>
    // import {json,wordData,utils} from '@/common/common.js'
    import {
        api,
        ajaxPost
    } from '@/common/request.js'
    export default {
        name: 'HelloWorld',
        data() {
            return {
                inputFeeNum:'',
                isLoading:false,
                photoArr1:['../../../static/images/service3.png','../../../static/images/service2.png'],
                photoArr2:['../../../static/images/service1.png'],
                infoObj:{
                    produce_order_taking_fee:'',
                    brand_order_detail_info:'',
                    produce_order_taking_detail_info:'',
                    produce_order_taking_notice_title:'',
                    produce_order_taking_notice_content:'',
                },
                
            }
        },
        filters: {
            times100: function(value) {
                let result=''
                if(!isNaN(value)){
                    result=value*100
                }else{
                    result=''
                }
                return result;
            }
        },
        methods: {
            refreshPage(){
                this.getInfo() 
                this.inputFeeNum=''
              
            },
            ajaxSubmit(arg){
                let _this=this
                ajaxPost('/app/updateConfigInfoByType',arg).then(function(res) {
                    if(res.errorCode==200){
                        _this.$message({
                            message: "修改成功", 
                            type: 'success',
                            duration: 1500
                        });
                        _this.refreshPage()
                    }
                }, function(res) {
                })
            },
            submitClick(keyword){
                let _this=this
                let currentValue=_this.infoObj[keyword]
                if(keyword=='produce_order_taking_fee'){//对费用单独做判断
                    let reg=/^(?:0|[1-9][0-9]?|100)$/;
                    if(reg.test(_this.inputFeeNum)){
                        
                        if(confirm("此项修改需谨慎，确认修改吗？")){
                            let arg1={
                                "showType":"3",
                                "configValue":_this.inputFeeNum/100,
                                "configName":keyword
                            }
                            _this.ajaxSubmit(arg1)
                        }
                        
                        
                    }else{
                        _this.$message("比例只能为1-100的整数数字")

                    }
                }else{
                    let arg2={
                        "showType":"3",
                        "configValue":currentValue,
                        "configName":keyword
                    }
                    _this.ajaxSubmit(arg2)
                }
            },
            getInfo(){
                let _this=this
                let arg={
                    showType:3 //1=app首页设置  2=认证短信设置   3=服务费设置
                }
                _this.isLoading=true
                ajaxPost('/app/showAppConfigInfo',arg).then(function(res) {
                    setTimeout(function(){
                        _this.isLoading=false
                    },300)
                    if(res.errorCode==200){
                        res.data.forEach(function(item,index){
                            let keyWord=item.config_name
                            _this.infoObj[keyWord]=item.config_value
                            
                        })
                    }
                }, function(res) {
                     _this.isLoading=false
                })
            }
        },
        mounted() {
            this.getInfo()
            
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .servicePercentWrap{
        .oneBtnBox{padding:10px;}
        
        .importantDes{color:blueviolet;font-weight: bold;margin-left: 10px;}
        textarea{border:1px solid #ccc;border-radius: 4px;vertical-align: top;padding:5px;}
        .panelBlock{
            padding:10px;border:1px solid #ddd; border-radius: 6px;margin:10px; background: #fff; box-shadow: 0 3px 10px #ccc;
            .panelTitle{padding:10px; color:darkblue;font-weight: bold;border-bottom: 1px dotted #ddd;}
            .panelContent{
                padding:10px;
            }
            .oneLine{
                padding:3px 0;
            }
        }
        
        .relativeBox.panelContent{
            position: relative;
            .rightImgBox{position: absolute;right: 120px;bottom:0px;
                img{height: 100px;margin-right: 15px;box-shadow: 0 0  3px  2px#ccc;}
            }
        }
        
    }
</style>



// WEBPACK FOOTER //
// src/pages/appPage/servicePercent.vue